@switch (columnName) {
  @case ('type') {
    {{ getTypeLabelKey() | translate }}
  }
  @case ('expires') {
    @if (element.isPaused) {
      <div class="paused-expires">
        <div class="paused-expires-title">{{ 'itemIsPaused' | translate }}</div>
        <div class="paused-expires-row">
          <span>{{ 'originalExpiry' | translate }}:</span>
          <span>{{ element.expires | date }}</span>
        </div>
        <div class="paused-expires-row">
          <span>{{ 'afterPauseExpiry' | translate }}:</span>
          <span>{{ element.estimatedExpiryDate | date }}</span>
        </div>
      </div>
    } @else {
      {{ element.expires | date }}
    }
  }
  @case ('status') {
    <div class="due-list-status-cell">
      <div
        class="status"
        [class.status-expired]="element?.status === 'Expired'"
        [class.status-expiring]="element?.status === 'Expiring'"
      ></div>
      @if (element.isPaused) {
        <app-department-paused-badge [iconOnly]="true"></app-department-paused-badge>
      }
    </div>
  }
  @case ('name') {
    <span class="due-list-name">
      @if (element.expirationReason && element.category === dueListModules.Medicine) {
        @if (element.expirationReason === ExpirationReasonEnum.ExpirationDate) {
          <span>
            {{ 'expirationReasonExpiredDate' | translate }}
          </span>
        }
        @if (element.expirationReason === ExpirationReasonEnum.StockUnderMinimum) {
          <span>
            {{ 'expirationReasonStockUnderMinimum' | translate }}
          </span>
        }
        @if (element.expirationReason === ExpirationReasonEnum.ExpiredAndUnderMinimum) {
          <span>
            {{ 'expirationReasonExpiredAndUnderMinimume' | translate }}
          </span>
        }
      }
      {{ element.name }}
    </span>
  }
  @case ('actions') {
    @if (
      element['category'] === dueListModules.Work ||
      element['category'] === dueListModules.Drill ||
      element['category'] === dueListModules.MaintenanceJob ||
      element['category'] === dueListModules.CorrectiveAction
    ) {
      <app-ui-button
        class="desktop-perform-action"
        appStopClickPropagation
        buttonType="icon-button"
        icon="done"
        [ariaLabel]="'perform' | translate"
        [title]="'perform' | translate"
        (click)="performSelectedItem()"
      ></app-ui-button>
      <app-ui-button
        class="mobile-perform-action"
        appStopClickPropagation
        buttonType="secondary"
        [text]="'perform' | translate"
        (click)="performSelectedItem()"
      ></app-ui-button>
    }
  }
  @case ('placement') {
    @if (element['location'] | isSingleLevelPlacement) {
      {{ element['location'] }}
    } @else {
      <span [matTooltip]="element['location']">
        {{ element['location'] | splitForLastChildren: '/' }}
      </span>
    }
  }
  @case ('responsible') {
    @for (responsible of element.responsibles ?? []; track responsible) {
      <div>
        {{ responsible }}
      </div>
    }
  }
  @case ('department') {
    @if (element.departmentId) {
      {{ element.departmentName }}
    }
  }
  @default {
    <app-default-cell [element]="element" [columnName]="columnName"></app-default-cell>
  }
}
